const panel = document.querySelector('.js-main-panel');
var daterange = document.querySelectorAll('.js-daterange');
const quick_book_property = new QuickBookProperty(panel);
class Booking_panel {
    constructor() {
        this.elements = document.querySelectorAll('[data-type="quick-book"]');
        this.panel = document.querySelector('.js-main-panel');
        this.daterange = this.panel.querySelector('.js-daterange') ?? false;
        this.promo = this.panel.querySelector('.js-promo-code') ?? false;
        this.guest = this.panel.querySelector('.js-booking-guest') ?? false;
        this.property = this.panel.querySelector('.js-booking-properties') ?? false;
        this.close_panel = this.panel.querySelectorAll('.js-close-panel');
        this.tab_group = this.panel.querySelector('.js-tab-group');
        this.tab_content_group = this.panel.querySelector('.js-tab-content-group');
        this.tabs = this.tab_group && Array.from(this.tab_group.getElementsByTagName('a'));
        this.tabs_content = this.tab_content_group && Array.from(this.tab_content_group.getElementsByClassName('js-tab-content'));
        this.booking_btn = this.panel.querySelector('.js-booking-btn');
        this.default_booking_link = document.getElementsByName('booking_engine_link');
        this.panel_cookie = {};
        this.guestInputSelector = ".voyager-booking__select-guest-widget";
        this.guestInput();
        this.getPanelCookie();
    }

    guestInput() {
        const { guestInputSelector } = this;
        document.querySelectorAll(guestInputSelector).forEach((widget) => {
            const input = widget.querySelector(`${guestInputSelector}-input`);
            const minusBtn = widget.querySelector(
                `${guestInputSelector}-button-minus`
            );
            const plusBtn = widget.querySelector(
                `${guestInputSelector}-button-plus`
            );
            const maxInput = parseInt(widget.dataset.maxInput);
    
            // Function to increase the value
            plusBtn?.addEventListener("click", () => {
                if (input.value >= maxInput) return;
                parseInt(input.value) > maxInput && (input.value = maxInput);
                if (input.value === "") input.value = 0;
                input.value = parseInt(input.value) + 1;
            });
    
            // Function to decrease the value
            minusBtn?.addEventListener("click", () => {
                if (input.value > parseInt(input.min)) {
                    input.value = parseInt(input.value) - 1;
                }
            });
    
            input?.addEventListener("input", (e) => {
                if (parseInt(e.target.value) > parseInt(maxInput)) {
                    e.target.value = maxInput;
                }
            });
        });
    }

    getPanelCookie() {
        var _self = this;
        let decoded_Cookie = decodeURIComponent(document.cookie);
        let cookie_array = decoded_Cookie.split(';');
        let name = 'quickBookPanelCookie=';
        for (let i = 0; i < cookie_array.length; i++) {
            let cookie = cookie_array[i].trim();

            if (cookie.indexOf(name) == 0) {
                _self.existing_cookie = JSON.parse(cookie.substring(name.length, cookie.length));
                _self.handleCookieGuest();
                _self.handleCookiePromo();
                // _self.handleCookieProperty();
            }
        }

        return '';
    }

    get_booking_element() {
        var _self = this;
        _self.elements.forEach(function (element) {
            _self.open_booking_panel(element);
        })
    }

    close_booking_panel() {
        var _self = this;
        _self.close_panel.forEach(function (element) {
            element.addEventListener('click', function () {
                _self.toggle_panel_class();
                _self.elements.forEach(function (el) {
                    el.classList.remove('is-active');
                });
            })
        });
    }

    toggle_panel_class() {
        var _self = this;
        _self.panel.removeAttribute('style');
        _self.panel.classList.toggle('js-hidden');
        _self.panel.classList.toggle('js-visible');
    }

    open_booking_panel(element) {
        var _self = this;

        element.addEventListener('click', function (e) {
            e.target.classList.toggle('is-active');
            quick_book_property.openMapwithPropery();
            _self.toggle_panel_class()
        })
    }

    get_tab_index() {
        var _self = this;
        _self.tabs.forEach(function (el, index) {
            el.addEventListener('click', function () {
                _self.remove_child_class(_self.tabs, 'is_active');
                _self.remove_child_class(_self.tabs_content, 'is_active');
                _self.add_class_on_tab_content(index);
                el.classList.add('is_active');
            });
        });
    }

    remove_child_class(parent_el, active_class) {
        parent_el.forEach(function (e, i) {
            if (e.classList.contains(active_class)) {
                e.classList.remove(active_class)
            }
        })
    };

    add_class_on_tab_content(i) {
        var _self = this;
        _self.tabs_content[i].classList.add('is_active');
    }

    removeLastSlash(url) {
        if (url.endsWith('/')) {
            return url.slice(0, -1);
        }
        return url;
    }

    handleCookieGuest() {
        var _self = this;
        if (_self.guest) {
            if (_self.existing_cookie.adults) {
                _self.setSelectedOption('adults', _self.existing_cookie.adults)
            }

            if (_self.existing_cookie.children) {
                _self.setSelectedOption('children', _self.existing_cookie.children)
            }
        }
    }

    handleCookiePromo() {
        var _self = this;

        if (_self.promo && _self.existing_cookie.promo) {
            _self.promo.querySelector('[name="promo"]').value = _self.existing_cookie.promo;
        }
    }

    handleCookieProperty() {
        var _self = this,
            variation = _self.property.dataset.variation;
        if (_self.property) {
            if (variation === 'location_property') {
                _self.setSelectedOption('voyager_booking_location', _self.existing_cookie.location)
                _self.setSelectedOption('voyager_booking_property', _self.existing_cookie.room)
            } else if (variation === 'location_taxonomy') {
                _self.setSelectedOption('voyager_booking_location', _self.existing_cookie.location)
            }
        }
    }

    setSelectedOption(name, value) {
        var element = document.querySelector('[name="' + name + '"]');

        if (element.type === 'select-one') {
            // Handle select option
            for (var i = 0; i < element.options.length; i++) {
                if (element.options[i].value === value) {
                    element.selectedIndex = i;
                    break;
                }
            }
        } else if (element.type === 'radio') {
            // Handle radio button
            var radioButtons = document.querySelectorAll('[name="' + name + '"]');
            for (var i = 0; i < radioButtons.length; i++) {
                if (radioButtons[i].value === value) {
                    radioButtons[i].checked = true;
                    break;
                }
            }
        }
    }

    get_booking_url() {
        var _self = this;
        if (_self.default_booking_link[0].value && typeof _self.booking_btn != 'undefined' && _self.booking_btn != null) {
            _self.booking_btn.addEventListener('click', function () {
                var query = _self.removeLastSlash(_self.default_booking_link[0].value);

                if (_self.property) {
                    var propertyLink = quick_book_property.getPropertyQuery();
                    if (propertyLink) {
                        query = propertyLink;
                    } else {
                        query += '/index.php?fw_submitted=1';
                    }
                } else {
                    query += '/index.php?fw_submitted=1';
                }

                if (_self.promo) {
                    query += _self.getPromoQuery();
                } else {
                    query += '&av=search';
                }

                if (_self.daterange) {
                    query += _self.getDateQuery();
                }

                if (_self.guest) {
                    query += _self.getGuestQuery();
                }

                var redirectURL = query;
                _self.handleCookie();
                // console.log(redirectURL);
                window.location = redirectURL;

            })

        }

    }

    handleCookie() {
        var _self = this,
            cookie = panel.dataset.cookie;

        if (cookie) {
            var panel_cookie_string = JSON.stringify(_self.panel_cookie);
            document.cookie = "quickBookPanelCookie=" + panel_cookie_string + "; expires=" + new Date(_self.panel_cookie.checkOut) + ";path=/";
        }
    }

    getDateQuery() {
        var _self = this,
            booking_checkIN = _self.panel.querySelector('[name="booking_checkIN"]').value,
            booking_checkOut = _self.panel.querySelector('[name="booking_checkOut"]').value,
            modifyCheckIN = _self.panel.querySelector('[name="checkin"]').value,
            modifyCheckOut = _self.panel.querySelector('[name="ckeckout"]').value;

        if (modifyCheckIN) {
            booking_checkIN = modifyCheckIN;
        }

        if (modifyCheckOut) {
            booking_checkOut = modifyCheckOut;
        }

        var date1 = new Date(booking_checkIN);
        var date2 = new Date(booking_checkOut);

        _self.panel_cookie.checkIn = booking_checkIN;
        _self.panel_cookie.checkOut = booking_checkOut;

        var Difference_In_Time = date2.getTime() - date1.getTime();
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        return '&checkin=' + booking_checkIN + '&nights=' + Difference_In_Days;
    }

    getPromoQuery() {
        var _self = this,
            promoValue = _self.promo.querySelector('[name="promo"]').value;
        if (promoValue) {
            _self.panel_cookie.promo = promoValue;

            return '&av=promo&searchPromoCode=' + promoValue;
        } else {
            return '&av=search';
        }
    }

    getGuestQuery() {
        var _self = this,
            adults = _self.guest.querySelector('[name="adults"]').value,
            children = _self.guest.querySelector('[name="children"]').value;

        var partya = "party=" + adults;
        if (children != 0) {
            partya = "partya=" + adults;
            for (let i = 0; i < children; i++) {
                partya += "%2C10";
            }
        }

        _self.panel_cookie.adults = adults;
        _self.panel_cookie.children = children;

        return '&' + partya;
    }

    variation_1_init() {
        this.get_booking_element();
        this.close_booking_panel();
        this.get_booking_url();
    }

    variation_2_init() {
        this.get_booking_element();
        this.close_booking_panel();
        this.get_booking_url();
    }

    variation_3_init() {
        this.get_booking_element();
        this.close_booking_panel();
        this.get_tab_index();
        this.get_booking_url();
    }

    variation_4_init() {
        this.get_booking_element();
        this.close_booking_panel();
        this.get_booking_url();
    }
}

if (typeof (panel) != 'undefined' && panel != null) {
    const booking_panel = new Booking_panel();
    const variation = panel.dataset.variation;
    if (variation == 'option_1') {
        booking_panel.variation_1_init();
    }

    if (variation == 'option_2') {
        booking_panel.variation_2_init();
    }

    if (variation == 'option_3') {
        booking_panel.variation_3_init();
    }

    if (variation === 'option_4') {
        booking_panel.variation_4_init();
    }

    if (daterange.length != 0) {
        let default_view_date = booking_panel.existing_cookie
        const daterange = new Daterange(default_view_date);
        daterange.init();
    }
}